import { Component, ViewChild } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';
import { ObservationService } from 'src/app/services/observation.service';
import { ContactTypeEnum } from 'src/app/shared/enums/contact-type.enum';
import { ObsForm } from 'src/app/shared/models/obs-form.model';
import { ObservationDetailsComponent } from '../observation/observation-details/observation-details.component';
import { internCertDetails } from 'src/app/shared/models/internCertDetails';
import { InternService } from 'src/app/services/intern.service';
import { GlobalService } from 'src/app/services/global.service';
import { FieldSupervisor } from 'src/app/shared/models/fsupervisor.model';
import { observations } from 'src/app/shared/models/observations';
import { StateEnum } from 'src/app/shared/enums/state.enum';
import { campus } from 'src/app/shared/models/campus';
import { FsContact } from 'src/app/shared/models/fs-contact.model';
import { FSContactsService } from 'src/app/services/fs-contacts.service';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ObsQuestionResponse } from 'src/app/shared/models/obs-question-response.model';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { ObservationFormErrorSheetComponent } from '../observation/observation-form-error-sheet/observation-form-error-sheet.component';
import { ObsDetailsComponent } from './obs-details/obs-details.component';
import { ObsDomainsComponent } from './obs-domains/obs-domains.component';
import { ObsSummaryComponent } from './obs-summary/obs-summary.component';
import { ObsConferenceComponent } from './obs-conference/obs-conference.component';
import { Result } from 'src/app/shared/models/result.model';
import { CachedFsContact } from 'src/app/shared/models/cached-fs-contact.model';
import { Subscription } from 'rxjs';
import { LocalStorageService } from 'src/app/services/local-storage.service';
import { ObsStatusEnum } from 'src/app/shared/enums/obs-Status.enum';
import { CompanyEnum } from 'src/app/shared/enums/company-enum.model';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmDialogComponent } from 'src/app/shared/confirm-dialog/confirm-dialog.component';

@Component({
  selector: 'app-obs-assessment',
  templateUrl: './obs-assessment.component.html',
  styleUrls: ['./obs-assessment.component.scss']
})
export class ObsAssessmentComponent {

  isLoading: boolean;
  internId: string;
  stateId: string;
  programId: string;
  assessmentId: any;
  completed: boolean;
  hasObservationConfiguration: boolean = false;
  showConfigurableObservation: boolean = false;
  saveButtonClicked: boolean = false;
  finishButtonClicked: boolean = false;
  disableSaveButton: boolean = false;
  disableShareDraftButton: boolean = true;
  cancelBackButtonText: string = 'CANCEL';
  legendText: string = 'Observation';
  fsContact: FsContact;
  obsForm: ObsForm = new ObsForm();
  lstcert: internCertDetails;
  isTexasObs: boolean;
  lstObservations: observations[] = [];
  fieldSupervisor: FieldSupervisor;
  nextObservation: observations;
  campus: campus = new campus();
  obsLoading: boolean;
  obsAssessmentForm: FormGroup;
  responseValidationFeedback: string[] = [];
  cachedFsContact: CachedFsContact;
  private formValueChangesSubscription: Subscription;
  profileId: string;
  isShareDraftOption: boolean = false;
  isTeach: boolean;

  @ViewChild(ObservationDetailsComponent) observationDetails: ObservationDetailsComponent;
  @ViewChild(ObsDetailsComponent) obsDetails: ObsDetailsComponent;
  @ViewChild(ObsDomainsComponent) obsDomains: ObsDomainsComponent;
  @ViewChild(ObsSummaryComponent) obsSummary: ObsSummaryComponent;
  @ViewChild(ObsConferenceComponent) obsConference: ObsConferenceComponent;

  constructor(private fb: FormBuilder,
    private authService: AuthService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private observationService: ObservationService,
    private fsContactsService: FSContactsService,
    private internService: InternService,
    private globalService: GlobalService,
    private bottomSheet: MatBottomSheet,
    private snackBar: MatSnackBar,
    private localStorageService: LocalStorageService,
    private dialog: MatDialog
  ) { }

  ngOnInit() {
    if (!this.authService.authenticated) {
      this.router.navigate(['auth']);
    }

    if (this.authService.authenticated) {
      if (this.globalService.supervisor != undefined) {
        this.fieldSupervisor = this.globalService.supervisor;
      }
    }

    this.internId = this.activatedRoute.snapshot.paramMap.get('id');
    this.assessmentId = this.activatedRoute.snapshot.paramMap.get('assessId');
    this.completed = this.activatedRoute.snapshot.paramMap.get('completed') === 'true' ? true : false;
    this.stateId = this.activatedRoute.snapshot.paramMap.get('stateId');
    let hasStaticObservation = this.activatedRoute.snapshot.paramMap.get('staticObs') === 'true' ? true : false;
    this.cancelBackButtonText = this.completed ? 'BACK' : 'CANCEL';
    this.profileId = this.activatedRoute.snapshot.paramMap.get('profileId');
    this.programId = this.activatedRoute.snapshot.paramMap.get('programId');

    if (!hasStaticObservation) {
      this.getObsForm();
      this.obsAssessmentForm = this.fb.group({});
      this.setupFormChangeDetection();
    }
  }

  setupFormChangeDetection() {
    this.formValueChangesSubscription = this.obsAssessmentForm.valueChanges.subscribe(() => {
      if (this.obsAssessmentForm.dirty) {
        this.saveFsContactToLocalCache();
      }
    });
  }

  onContactDateChange(updatedContactDate: string) {
    if (this.fsContact) {
      this.fsContact.contactDate = updatedContactDate;
    }
  }

  getObsForm() {
    this.isLoading = true;
    this.observationService.GetObsForm(this.programId).subscribe({
      next: (result) => {
        if (result.success && result.returnObj) {
          this.obsForm = result.returnObj as ObsForm;
          if (this.obsForm) {
            this.hasObservationConfiguration = true;
            this.getInternsDetails();
          }
        }
        else {
          console.log(result.userMsg);
        }
        this.isLoading = false;
      },
      error: (errorObj) => {
        this.isLoading = false;
        if (errorObj.error && errorObj.error.userMsg) {
          console.log(errorObj.error.userMsg);
        }
        else {
          console.log(errorObj);
          this.snackBar.open('An error occurred while loading new observation form', 'Ok', { panelClass: 'custom-snackbar' });
        }
      }
    });
  }

  onContactTypeChange(contactTypeId: Number) {
    // Check for TX 2024 informal observation restrictions
    if (contactTypeId.toString() === ContactTypeEnum.InformalObservation.toString()) {
      const validationError = this.validateInformalObservationSelection();
      if (validationError) {
        this.showInformalObservationError(validationError);
        this.showConfigurableObservation = false;
        return;
      }
    }

    if (!this.hasObservationConfiguration || contactTypeId.toString() !== ContactTypeEnum.Observation.toString()) {
      this.showConfigurableObservation = false;
      return;
    }

    // If contact is already loaded, just show the configurable observation
    if (this.fsContact) {
      this.showConfigurableObservation = true;
      return;
    }

    // Find earliest incomplete scheduled observations
    const earliestFsContact = this.lstcert.FsContacts?.find(contact => contact.ObsTypeId === ContactTypeEnum.Observation && contact.ObsStatusId === ObsStatusEnum.Scheduled);

    const earliestObservation = this.lstcert.Observations?.find(contact => contact.ObsMethodId === ContactTypeEnum.Observation && contact.ObsStatusId === ObsStatusEnum.Scheduled);

    // Determine which assessment to load based on scheduled dates
    const assessmentIdToLoad = this.getEarliestAssessmentId(earliestFsContact, earliestObservation);

    if (assessmentIdToLoad) {
      this.getFsContact(assessmentIdToLoad);
    }
  }

  private getEarliestAssessmentId(fsContact: any, observation: any): number | null {
    if (!fsContact && !observation) {
      return null;
    }

    if (!fsContact) {
      return observation.AssessmentId;
    }

    if (!observation) {
      return fsContact.AssessmentId;
    }

    // Convert scheduled dates to Date objects for proper comparison
    const fsContactDate = new Date(fsContact.ScheduledDate);
    const observationDate = new Date(observation.ScheduledDate);

    return fsContactDate <= observationDate ? fsContact.AssessmentId : observation.AssessmentId;
  }

  getInternsDetails() {
    this.lstcert = new internCertDetails;
    this.internService.getInternDetailsById(this.internId, this.fieldSupervisor.FieldSupervisorId).subscribe(data => {
      this.lstcert = data;
      this.isTexasObs = this.lstcert?.Intern?.stateId == StateEnum.TX;
      this.isTeach = this.lstcert?.Intern?.companyId == CompanyEnum.Teach;
      this.campus = this.lstcert?.Campus;
      this.LoadObservations();

      if (this.assessmentId) {
        this.getFsContact(this.assessmentId);
      }
    });

  }

  LoadObservations() {
    this.lstcert.Certificates.forEach(element => {
      element.Observations.forEach(obs => {
        if (!(obs.IsCompleted || obs.IsSaved) || this.assessmentId) {
          this.lstObservations.push(obs);
        }
      });
    });

    this.nextObservation = this.lstObservations[0];
  }

  getFsContact(assessmentId: number) {
    this.obsLoading = true;
    this.fsContactsService.GetFSContact(assessmentId).subscribe({
      next: result => {
        if (result.success && result.returnObj) {
          this.fsContact = result.returnObj as FsContact;

          if (this.fsContact.contactDate) {
            this.observationDetails.obsAssessment.Date = this.fsContact.contactDate;
          } else {
            this.fsContact.contactDate = this.observationDetails.obsAssessment.Date;
          }

          if (this.fsContact.contactTypeId) {
            this.observationDetails.obsAssessment.ContactTypeId = this.fsContact.contactTypeId;
          }

          this.loadCachedFsContact();

          this.showConfigurableObservation = true;
        }
        this.obsLoading = false;
      },
      error: () => {
        this.obsLoading = false;
        this.observationDetails.obsAssessment.ContactTypeId = 0;
        this.snackBar.open('An error occurred while loading observation', 'Ok', { panelClass: 'custom-snackbar' });
      }
    });
  }

  finishAssessment() {
    this.finishButtonClicked = true;
    if (this.formalObsValidation(true)) {
      this.mapFormToFsContact();
      this.fsContactsService.FinishFsContact(this.fsContact).subscribe({
        next: (result) => {
          if (result.success) {
            if (Array.isArray(result.returnObj) && result.returnObj.length > 0) {
              const data = result.returnObj as string[];
              const emailRecipients = [
                data.slice(0, -1)
                  .join(', '),
                ...data.slice(-1)]
                .filter(x => x)
                .join(' and ');
              this.openSnackBar(`Completed Observation is queued to be emailed to ${emailRecipients}`, 'Ok', 10000)
              this.clearCachedFsContact();
            }
            this.router.navigate(['/intern-details', this.internId]);
          }
          else {
            this.HandleFinishAssessmentError(result);
          }
          this.finishButtonClicked = false;
        },
        error: (errorObj) => {
          if (errorObj.error && errorObj.error.userMsg) {
            this.openSnackBar(errorObj.error.userMsg, 'Ok');
          }
          else {
            this.openSnackBar('An error occurred while submitting observation form', 'Ok');
          }
          this.finishButtonClicked = false;
        }
      });
    }
    else {
      this.finishButtonClicked = false;
    }
  }

  HandleFinishAssessmentError(result: Result) {
    switch (result.statusCode) {
      case 'VALIDATION_FAILED': {
        if (Array.isArray(result.returnObj)) {
          let errorList: string[] = result.returnObj as string[];
          this.responseValidationFeedback = [];
          this.responseValidationFeedback.push(...errorList);
          if (this.responseValidationFeedback.length > 0) {
            this.showErrorList(true);
          }
        }
        break;
      }

      case 'PDF_GENERATION_FAILED':
      case 'EMAIL_SEND_FAILED': {
        this.openSnackBar(result.userMsg, 'Ok', 10000);
        this.router.navigate(['/intern-details', this.internId]);
        break;
      }

      case 'ASSESSMENT_SUBMISSION_FAILED':
      default: {
        this.openSnackBar('An error occurred while submitting observation form', 'Ok');
      }
    }
  }

  shareDraftAssessment() {
    this.isShareDraftOption = true;
    this.fsContact.isShareDraftOption = true;
    this.saveAssessment();
  }

  saveAssessment() {
    this.saveButtonClicked = true;
    if (this.formalObsValidation()) {
      this.mapFormToFsContact();
      this.fsContactsService.UpdateFsContact(this.fsContact).subscribe({
        next: (result) => {
          if (result.success) {

            const successMessage = this.isShareDraftOption
              ? "Observation saved and observation draft emailed to Intern"
              : "Observation form saved successfully";

            this.openSnackBar(successMessage, "Ok");
            this.clearCachedFsContact();
            this.router.navigate(['/intern-details', this.internId]);
          }
          else {
            if (Array.isArray(result.returnObj)) {
              let errorList: string[] = result.returnObj as string[];
              this.responseValidationFeedback = [];
              this.responseValidationFeedback.push(...errorList);
              if (this.responseValidationFeedback.length > 0) {
                this.showErrorList();
              }
            }
            else {
              const errorMessage = result.userMsg?.trim()
                ? result.userMsg
                : this.isShareDraftOption
                  ? "An error occurred while saving the observation and sharing the draft."
                  : "An error occurred while saving observation form";

              this.openSnackBar(errorMessage, "Ok");
            }
          }
          this.saveButtonClicked = false;
          this.isShareDraftOption = false;
          this.fsContact.isShareDraftOption = false;
        },
        error: (errorObj) => {
          if (errorObj.error && errorObj.error.userMsg) {
            this.openSnackBar(errorObj.error.userMsg, 'Ok');
          }
          else {
            const errorMessage = this.isShareDraftOption
              ? "An error occurred while saving the observation and sharing the draft"
              : "An error occurred while saving observation form";

            this.openSnackBar(errorMessage, "Ok");
          }
          this.saveButtonClicked = false;
          this.isShareDraftOption = false;
          this.fsContact.isShareDraftOption = false;
        }
      });
    }
    else {
      this.saveButtonClicked = false;
      this.isShareDraftOption = false;
      this.fsContact.isShareDraftOption = false;
    }
  }

  formalObsValidation(finishing: boolean = false): boolean {
    this.responseValidationFeedback = [];

    this.ValidateContactDate();

    let obsDetailsErrors = this.obsDetails.validateForm();
    let obsDomainsErrors = this.obsDomains.validateForm(finishing || this.isShareDraftOption);
    let obsSummaryErrors = this.obsSummary.validateForm(finishing || this.isShareDraftOption);
    let obsConferenceErrors = this.isShareDraftOption ? this.obsConference.validateFormForShareDraft() : this.obsConference.validateForm(finishing);

    this.responseValidationFeedback = [
      ...this.responseValidationFeedback,
      ...obsDetailsErrors,
      ...obsDomainsErrors,
      ...obsSummaryErrors,
      ...obsConferenceErrors
    ];

    if (this.responseValidationFeedback.length > 0) {
      this.showErrorList(finishing);
      return false;
    }
    return true;
  }

  private ValidateContactDate() {
    let contactDateError = this.observationDetails.ValidateContactDate();
    if (this.observationDetails.ValidateContactDate()) {
      this.responseValidationFeedback.push(contactDateError);
    }
  }

  private showErrorList(finishing: boolean = false) {
    let method = finishing ? 'finish' : 'save';

    method = this.shareDraftAssessment ? 'share draft' : method;

    this.bottomSheet.open(ObservationFormErrorSheetComponent, {
      data: {
        title: `Please provide the information listed below to ${method} your observation.`,
        messages: this.responseValidationFeedback
      }
    });
  }

  mapFormToFsContact() {
    this.fsContact.contactDate = this.observationDetails.obsAssessment.Date;
    this.fsContact.contactTypeId = ContactTypeEnum.Observation;
    this.fsContact.campusId = this.fsContact.campusId ?? this.campus?.CampusId ?? null;
    this.fsContact.fsFullName = this.fieldSupervisor.FirstName + ' ' + this.fieldSupervisor.LastName;
    this.fsContact.fsId = this.fieldSupervisor.FieldSupervisorId ?? this.fsContact.fsId;
    this.fsContact.fsEmail = this.fieldSupervisor.PrimaryEmail;
    this.fsContact.isFullTimeEmployee = this.fieldSupervisor.isFullTimeEmployee;
    this.fsContact.stateId = this.stateId;
    this.fsContact.fsObservation.obsForm = this.obsForm;

    const obsDetailsValues = this.obsAssessmentForm.getRawValue().obsDetails;
    const obsSummaryValues = this.obsAssessmentForm.get('obsSummary')?.value;
    const obsConferenceValues = this.obsAssessmentForm.get('obsConference')?.value;
    const obsDomainsValues = this.obsAssessmentForm.get('obsDomains')?.value;

    this.fsContact.fsObservation = {
      ...this.fsContact.fsObservation,
      ...obsDetailsValues,
      ...obsSummaryValues,
      ...obsConferenceValues
    };

    if (obsDomainsValues) {
      this.mapObsDomainsValuesToResponses(obsDomainsValues);
    }
  }

  mapObsDomainsValuesToResponses(obsDomainsValues: any) {
    this.fsContact.fsObservation.obsQuestionResponses = [];

    Object.entries(obsDomainsValues).forEach(([questionId, response]) => {
      const newResponse = new ObsQuestionResponse();
      newResponse.id = +questionId;
      newResponse.response = response;

      for (const domain of this.obsForm.obsDomains) {
        for (const category of domain.obsCategories) {
          if (category.obsQuestions.some(question => question.id === newResponse.id)) {
            newResponse.obsCategoryId = category.id;
            newResponse.obsCategoryDescription = category.description;
            let obsQuestion = category.obsQuestions.find(q => q.id === newResponse.id);
            newResponse.responseTypeId = obsQuestion.responseTypeId;
            newResponse.obsQuestionDescription = obsQuestion.description;
          }
        }
      }

      this.fsContact.fsObservation.obsQuestionResponses.push(newResponse);
    });
  }

  cancel() {
    this.formValueChangesSubscription.unsubscribe();
    var backupRestored = this.localStorageService.restoreBackupCachedItem(`fsContact-${this.fsContact.assessmentId.toString()}`);

    var message = backupRestored ? 'Previous locally saved contact form data restored' : 'Contact form data not saved locally';
    this.openSnackBar(message, 'Ok');

    this.router.navigate(['/intern-details', this.internId]);
  }

  openSnackBar(data: string, status: string, duration: number = 5000) {
    this.snackBar.open(data, status, {
      duration: duration,
      panelClass: 'custom-snackbar'
    });
  }

  onRequiredDetailsInvalid(requiredDetailsInvalid: boolean) {
    this.disableSaveButton = requiredDetailsInvalid;
  }

  saveFsContactToLocalCache(): void {
    this.mapFormToFsContact();

    if (!this.cachedFsContact) {
      this.cachedFsContact = new CachedFsContact();
    }

    this.cachedFsContact.assessmentId = this.fsContact.assessmentId;
    this.cachedFsContact.fsContact = this.fsContact;
    this.cachedFsContact.profileId = this.lstcert?.Intern?.profileId;
    this.cachedFsContact.saveDate = new Date();

    this.localStorageService.saveItemToCache(`fsContact-${this.fsContact.assessmentId.toString()}`, this.cachedFsContact);
  }

  loadCachedFsContact(): void {
    try {
      const cachedFsContact = this.localStorageService.loadItemFromCacheWithBackup<CachedFsContact>(`fsContact-${this.fsContact.assessmentId.toString()}`);

      if (cachedFsContact &&
        cachedFsContact.profileId === this.lstcert?.Intern?.profileId &&
        cachedFsContact.assessmentId === this.fsContact.assessmentId) {
        this.fsContact = cachedFsContact.fsContact;
      }
    } catch (error) {
      console.error('Error loading observation assessment from local storage:', error);
      this.openSnackBar('An error occurred while loading the observation assessment. Please try again.', 'Ok');
    }
  }

  clearCachedFsContact(): void {
    this.formValueChangesSubscription.unsubscribe();
    this.localStorageService.removeAllCachedItemsByKey(`fsContact-${this.fsContact.assessmentId.toString()}`);
  }

  onPreConferenceValidityChanged(isPreconferenceValid: boolean): void {
    this.disableShareDraftButton = !isPreconferenceValid;
  }

  private isTx2024RuleSet(): boolean {
    const ruleSet = this.lstcert?.Intern.RuleSet;
    if (!ruleSet) {
      return false;
    }
    const year = ruleSet.trim().substring(ruleSet.length - 4);
    const ruleSetYear = parseInt(year);
    return ruleSetYear >= 2024;
  }

  private validateInformalObservationSelection(): string | null {

    if (!this.isTx2024RuleSet() || this.stateId !== StateEnum.TX.toString()) {
      return null;
    }

    const firstFormalObs = this.lstcert.FsContacts?.find(contact => contact.ObsTypeId === ContactTypeEnum.Observation && contact.ObsType.toLocaleLowerCase().startsWith('first'));

    if (!firstFormalObs) {
      return null;
    }

    // Check if first formal observation is submitted or beyond
    const isSubmittedOrAccepted = firstFormalObs.ObsStatusId > ObsStatusEnum.Saved;

    if (!isSubmittedOrAccepted) {
      return 'First formal observation needs to be completed before first informal observation';
    }

    return null;
  }

  private showInformalObservationError(errorMessage: string): void {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '400px',
      data: {
        title: 'Validation Error',
        message: errorMessage,
        hideCancelButton: true,
        confirmButtonText: 'OK'
      }
    });
  }
}
